import React from "react";
import { view } from "../../lib/vvm";
import {
  TelegramLoginWidgetViewModel,
  type TelegramLoginWidgetViewProps,
} from "./TelegramLoginWidgetViewModel";
import styles from "./TelegramLoginWidget.module.css";

type TelegramLoginWidgetProps = TelegramLoginWidgetViewProps & {
  className?: string;
};

export const TelegramLoginWidget: React.FC<TelegramLoginWidgetProps> = view(
  TelegramLoginWidgetViewModel,
)<TelegramLoginWidgetProps>(({
  className = "",
  viewModel: { containerRef },
}) => {
  return <div ref={containerRef} className={`${styles.root} ${className}`} />;
});
